export default __webpack_public_path__ + "static/media/Compacer.6d25743c.png";